import { DICTIONARY_OPERATION_TO_GEOFENCE_EVENT_KIND } from 'constants/MeshbotConstant';

/**
 * Converts a dictionary operation (e.g., 'added') to an eventKind (e.g., 'arrive').
 *
 * @param {string} operation - The backend dictionary operation.
 * @returns {string|undefined} The corresponding UI event kind.
 *
 * @example
 * convertDictionaryOperationToEventKind('removed'); // ➜ 'leave'
 */
export const convertDictionaryOperationToEventKind = (operation) =>
    DICTIONARY_OPERATION_TO_GEOFENCE_EVENT_KIND[operation];
